import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { UsersService } from "./services/users.service";
import { Observable, Subscriber } from "rxjs";
import { environment } from "../environments/environment.prod";

@Injectable({
  providedIn: 'root'
})
export class loginGuard implements CanActivate {


  constructor(private router: Router, private userService: UsersService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Observable<UrlTree | boolean> {
    return new Observable<boolean | UrlTree>(obs => {
      console.log('login gourd')

      if (this.userService.isLoggedIn()) {//אם המשתמש מחובר אפשר להכנס
        console.log('logged in')
        obs.next(true)
      }
      else {
        const loginParam = next.queryParamMap.get('login');
        // const passParam = next.queryParamMap.get('PASS');
        console.log(loginParam)
        if (loginParam === 'nativ-advs') {
          console.log('nativ-advs')
          this.userService.getUser('nativ-advs').subscribe(u => {
            console.log('get user', u)
            localStorage.setItem('user', JSON.stringify(u))
            this.userService.login(state.url)
            obs.next(true)
          }, e => { return false })
          obs.next(true)
        }
        else {
          console.log('try nativ login')
          this.userService.shortNativLogin().subscribe(d => {
            console.log('nativ login', d)
            this.userService.sessionDetails.next(d)
              this.userService.getUser(d['UserName']).subscribe(u => {
                console.log('get user', u)
                localStorage.setItem('user', JSON.stringify(u))
                this.userService.login(state.url)
                obs.next(true)
              }, e => {
                return false
              })

          },
            e => {
              console.log('try nativ login failed', e)
              this.checkElta(obs, state)
            })
        }
      }
    })
  }

  checkElta(obs: Subscriber<boolean | UrlTree>, state: RouterStateSnapshot) {
    console.log('try elta login')
    this.userService.getUserIp1().subscribe(result => {
      this.userService.checkIfEltaUser(result.ip).subscribe(isElta => {
        if (isElta) {
          this.userService.getUser('elta-server').subscribe(u => {
            console.log('get user', u)
            localStorage.setItem('user', JSON.stringify(u))
            this.userService.login(state.url)
            obs.next(true)
          }, e => {
            this.checkElta2(obs, state)
          })
        } else {
          this.checkElta2(obs, state)
        }
      }, error => {
        this.checkElta2(obs, state)
      })
    }, e => {
      console.log('try getUserIp1  failed', e)
      this.loginFromLocalstorage(obs, state)
    })
  }

  checkElta2(obs: Subscriber<boolean | UrlTree>, state: RouterStateSnapshot) {
    this.userService.getUserIp2().subscribe(result2 => {
      this.userService.checkIfEltaUser(result2.ip).subscribe(isElta => {
        if (isElta) {
          this.userService.getUser('elta-server').subscribe(u => {
            console.log('get user', u)
            localStorage.setItem('user', JSON.stringify(u))
            this.userService.login(state.url)
            obs.next(true)
          }, e => {
            this.loginFromLocalstorage(obs, state)
          })
        }
        else {
          this.loginFromLocalstorage(obs, state)
        }
      }, error => {
        this.loginFromLocalstorage(obs, state)
      })
    }, e => {
      this.loginFromLocalstorage(obs, state)
    })
  }

  loginFromLocalstorage(obs: Subscriber<boolean | UrlTree>, state: RouterStateSnapshot) {

    //התאריך של הכניסה האחרונה
    const lastLoginDate = new Date(JSON.parse(localStorage.getItem('lastLoginTime')))
    // Get the current date and time
    const currentDate = new Date();

    // Calculate the time difference in milliseconds
    const timeDiff = currentDate.getTime() - lastLoginDate.getTime();

    // Calculate the number of milliseconds in a week
    const oneWeekInMilliseconds = 7 * 24 * 60 * 60 * 1000;

    if (timeDiff >= oneWeekInMilliseconds) {//אם עבר שבוע מהכניסה האחרונה
      console.log('more than a week since last login')
      localStorage.clear()
      obs.next(this.router.createUrlTree(['/signin'], { queryParams: { nextRoute: state.url } }));
    }
    else {
      if (!localStorage.getItem('user')) {//אם אין משתמש רשום
        console.log('to login screen')
        obs.next(this.router.createUrlTree(['/signin'], { queryParams: { nextRoute: state.url } }));
      }
      else {
        console.log('auto login')
        this.userService.login(state.url)
        obs.next(true);
      }


    }
  }
}